import React from 'react';
import {ReactComponent as ToReleaseIcon} from '../../../../assets/icons/fire-user.svg';
import AvatarSpectator from '../../../../assets/images/avatars/avatar-spectator.png';
import AvatarUser from '../../../../assets/images/avatars/avatar-users.png';
import {ReactComponent as UseAddIcon} from '../../../../assets/icons/user-add.svg';
import './Customers.scss';
import {IconButtonMUI} from '../../../../shared';
import {useTranslation} from 'react-i18next';
import {ReactComponent as SettingsIcon} from '../../../../assets/images/profile/Menu/project3.svg';
import {useSelector} from "react-redux";

const Customers = ({
                       firstName,
                       position,
                       isActive,
                       avatar,
                       id,
                       handleId,
                       onBlock,
                       roleName,
                       onReturn,
                       editPermission,
                       phone,
                       email,
                       onEditUser,
                       editPerson,
                       projectNames = [],
                       blockCustomerPermission = false,
                       returnCustomerPermission = false

                   }) => {
    const {t} = useTranslation();
    const profileMe = useSelector((state) => state.profile.profileMe);

    const isMe = profileMe?.id === id;
    return (
        <div className='customers' key={id}>
            <div className='customers__info'>
                <div className='customers__info-avatar'>
                    {avatar ? (
                        <img className='avatar-image' src={avatar} alt={firstName}/>
                    ) : position === 'spectator' ? (
                        <img className='avatar-image' src={AvatarSpectator} alt={firstName}/>
                    ) : (
                        <img className='avatar-image' src={AvatarUser} alt={firstName}/>
                    )}

                    {isActive === true ? <div className='status active'/> : <div className='status'/>}
                </div>
                <div className='customers__info-user'>
                    <div className='customers__info-name' onClick={handleId}>
                        {firstName}
                    </div>
                    {projectNames?.length > 0 ? (
                        <div className='customers__info-role'>
                            {roleName} {projectNames.length === 1 ? t('all.projectMember') : t('all.projectMembers')}{' '}
                            <span>({projectNames?.join(', ')})</span>
                        </div>
                    ) : (
                        <div className='customers__info-role'>{roleName}</div>
                    )}
                </div>
            </div>

            <div className='customers__btns'>
                {isActive && blockCustomerPermission && !isMe && (
                    <div className='customers__btn' onClick={() => onBlock(id)}>
                        <IconButtonMUI color={'inherit'} title={t('CustomerInner.block')}>
                            <ToReleaseIcon/>
                        </IconButtonMUI>
                    </div>
                )}
                {!isActive && returnCustomerPermission && !isMe && (
                    <div className='customers__btn' onClick={() => onReturn(id)}>
                        <IconButtonMUI color={'inherit'} title={t('EmployeesInner.return')}>
                            <UseAddIcon/>
                        </IconButtonMUI>
                    </div>
                )}
                {editPerson && (
                    <div
                        className='customers__btn'
                        onClick={() =>
                            onEditUser({
                                id: id,
                                name: firstName,
                                avatar: avatar,
                                email: email,
                                phone: phone
                            })
                        }
                    >
                        <IconButtonMUI color={'inherit'} title={t('dictionaries.edit')}>
                            <SettingsIcon/>
                        </IconButtonMUI>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Customers;
